export const isNormalizedNestedStructure = (slides: unknown) => {
  return !!(
    Array.isArray(slides) &&
    slides.length > 0 &&
    slides[0].id &&
    slides[0].children
  );
};
